import { render } from "./App.vue?vue&type=template&id=216d4370&xmlns=http%3A%2F%2Fwww.w3.org%2F1999%2Fhtml"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__